import React from "react";
import "../Style/HomePage.css";
import NavBar from "../Components/NavBar.js";
import HeroSection from "../Components/HeroSection.js";
import PhilosophySection from "../Components/PhilosophySection.js";
import WhatWeCurate from "../Components/WhatWeCurate.js";
import Testimonials from "../Components/Testimonials.js";
import Footer from "../Components/Footer.js";

function HomePage() {
  return (
    <div className="home-page-view">
      <div className="top-section">
        <NavBar />
        <HeroSection />
      </div>
      <PhilosophySection />
      <WhatWeCurate />
      <Testimonials />
      <Footer />
    </div>
  );
}

export default HomePage;
